import { render, staticRenderFns } from "./MakeWochitButton.vue?vue&type=template&id=b250899c&scoped=true&"
import script from "./MakeWochitButton.vue?vue&type=script&lang=js&"
export * from "./MakeWochitButton.vue?vue&type=script&lang=js&"
import style0 from "./MakeWochitButton.vue?vue&type=style&index=0&id=b250899c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b250899c",
  null
  
)

export default component.exports